import script from "./LayoutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&setup=true&lang=js"

import "./LayoutComponent.vue?vue&type=style&index=0&id=5b0d950f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0d950f"]])

export default __exports__